import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Modal,
  ModalFooter,
} from '@folio/stripes/components';

function ClearanceBlockedModal(props) {
  const { onCloseModal, openTransactions, username } = props;

  const renderFooter = (
    <ModalFooter>
      <Button
        data-test-clearance-blocked-button-ok
        id="close-clearance-blocked-button"
        onClick={onCloseModal}
      >
        <FormattedMessage id="ui-users.okay" />
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      id="clearance-blocked-modal"
      data-test-clearance-blocked-modal
      open
      label={<FormattedMessage id="ui-users.clearance.blocked.title" />}
      footer={renderFooter}
    >
      <FormattedMessage
        id="ui-users.clearance.blocked.info"
        values={{ name: username }}
      />
      <ul>
        <li><FormattedMessage id="ui-users.details.openLoans" />: {openTransactions.loans}</li>
        <li><FormattedMessage id="ui-users.details.openRequests" />: {openTransactions.requests}</li>
        <li><FormattedMessage id="ui-users.details.openFeesFines" />: {openTransactions.feesFines}</li>
        <li><FormattedMessage id="ui-users.details.openBlocks" />: {openTransactions.blocks}</li>
        <li><FormattedMessage id="ui-users.details.openUnexpiredProxy" />: {openTransactions.proxies}</li>
      </ul>
      <FormattedMessage id="ui-users.clearance.blocked.resolve" />
    </Modal>
  );
}

ClearanceBlockedModal.propTypes = {
  username: PropTypes.string.isRequired,
  openTransactions: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default ClearanceBlockedModal;